<template>
    <right-drawer
        :show-drawer="filterDrawer"
        drawer-width="500px"
        drawer-title-class="filter-title"
        class="filter-drawer"
    >
        <template v-slot:drawerTitle>
            <div class="ma-0 pa-4 d-flex filter-title">
                <v-icon class="mr-4" @click="filterDrawer = !filterDrawer" color="#FFF">mdi-arrow-right</v-icon>
                Filtro de Relatório
            </div>
        </template>
        <template v-slot:drawerBody>
            <div class="pa-4 filter-form">
                <slot name="form"></slot>
            </div>
        </template>
        <template v-slot:drawerActions>
            <div class="pa-4 w-100">
                <v-btn width="49%" color="#f2c037" class="clean-btn" @click="$emit('clear-filter')">
                    Limpar
                </v-btn>
                <v-btn width="49%" color="primary" @click="$emit('apply-filter')">
                    Aplicar
                </v-btn>
            </div>
        </template>
    </right-drawer>
</template>

<script>
import RightDrawer from "../Modals/RightDrawer.vue";

export default {
    name: "FilterDrawer",
    components: {RightDrawer},

    props: [
        'showDrawer'
    ],

    data: () => ({
        filterDrawer: false,
    }),

    methods: {

    },

    watch: {
        showDrawer: function() {
            this.filterDrawer = !this.filterDrawer;
        },
    }
}
</script>

<style scoped>
.filter-title {
    background-color: #1976d2;
    color: #FFF;
    width: 100%;
    height: 100%;
}

.filter-form >>> form .v-input {

}

.clean-btn {
    color: #FFF;
}
</style>
